import {
    type FC
} from "react";
import {
    Pressable,
    Animated,
    View
} from "react-native";
import type ITreeViewToggleProps from "./type";
import stylesheet, {
    getTreeViewToggleRotation,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import {
    useTreeViewContext
} from "../../context";
import {
    ChevronRight as ChevronRightIcon
} from "lucide-react-native";
import {
    TREE_VIEW_PART_TAB_INDEX
} from "../../util";
import Loading from "../../../loading";
import Icon from "../../../icon";

const TreeViewToggle: FC<ITreeViewToggleProps> = ({
    isExpandable,
    isExpanded,
    isLoading,
    onPress,
    color
}) => {
    const {
        customTheme,
        measures
    } = useTreeViewContext();

    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const progress = useAnimatedState({
        intent: isExpanded ? "expand" : "collapse",
        value: isExpanded ? 1 : 0,
        customTheme
    });

    const {
        slot: slotDynamicStyle
    } = useStyles({
        isExpandable,
        measures
    });

    const renderGlyph = () => {
        if(isLoading) {
            return <Loading
                customTheme={customTheme}
                size={measures.iconSize}
                customColor={color}
                aria-hidden={true}
            />;
        }

        if(!isExpandable) {
            return null;
        }

        return <Animated.View
            style={{
                transform: [
                    {
                        rotate: progress.interpolate({
                            outputRange: getTreeViewToggleRotation({
                                direction
                            }),
                            inputRange: [
                                0,
                                1
                            ]
                        })
                    }
                ]
            }}
        >
            <Icon
                customTheme={customTheme}
                size={measures.iconSize}
                icon={ChevronRightIcon}
                customColor={color}
            />
        </Animated.View>;
    };

    if(!isExpandable) {
        return <View
            style={[
                stylesheet.slot,
                slotDynamicStyle
            ]}
            aria-hidden={true}
        >
            {renderGlyph()}
        </View>;
    }

    return <Pressable
        tabIndex={TREE_VIEW_PART_TAB_INDEX}
        style={[
            stylesheet.slot,
            slotDynamicStyle
        ]}
        aria-hidden={true}
        focusable={false}
        onPress={onPress}
    >
        {renderGlyph()}
    </Pressable>;
};
export default TreeViewToggle;
